// extracted by mini-css-extract-plugin
module.exports = {"inner_card":"Automated_inner_card__1UAXx","heading":"Automated_heading__2ru1Z"};